module.exports = __webpack_public_path__ + "static/media/godzilla.366b7cfa.png";